import React from 'react';
import { appStrings } from "./strings"
import { interpolateLocaleString } from "../../../helpers/interpolateLocaleString";

export interface AppTextProps {
  textKey: string
  values?: { [key: string]: any }
}

function AppText(props: AppTextProps) {
  let text = appStrings[props.textKey] ?? props.textKey
  text = interpolateLocaleString(text, props.values);
  if (text.indexOf('<') >= 0) {
    return (<div dangerouslySetInnerHTML={{ __html: text }} />);
  }
  else {
    return (<>{text}</>);
  }
}

export default AppText;